import React from 'react'
import Icon from '../Icon'

class SortableTableHeader extends React.Component {
  constructor(props) {
    super(props)
    this.onClick = this.onClick.bind(this)
  }

  onClick() {
    this.props.onClick(this.props.keyName, this.props.asc)
  }

  generateClass() {
    const {
      center,
      middle,
    } = this.props
    const classes = []
    if (center) {
      classes.push('uk-text-center')
    }
    if (middle) {
      classes.push('uk-text-middle')
    }
    return classes.join(' ')
  }

  render() {
    return (
      <th
        className={this.generateClass()}
        style={this.props.style || {}}
      >
        <div
          className={`uk-flex uk-flex-middle${this.props.center ? ' uk-flex-center' : ''}`}
        >
          <span>
            {this.props.name}
          </span>
          {
            !this.props.notSortable && (
              <Icon
                className={`uk-margin-small-left${this.props.active ? ' uk-text-primary' : ''}`}
                name={this.props.asc || !this.props.active ? 'arrow-down' : 'arrow-up'}
                ratio={0.8}
                onClick={this.onClick}
              />
            )
          }
        </div>
      </th>
    )
  }
}

export default SortableTableHeader
